var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.23077,
    y: 1.23077,
    width: 157.538,
    height: 157.538,
    rx: 78.7692,
    stroke: "#1BC98E",
    strokeWidth: 2.46154
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.887 42.459H56.5121C46.7551 42.459 38.8455 50.3686 38.8455 60.1257V99.8756C38.8455 109.633 46.7551 117.542 56.5121 117.542H102.887C112.644 117.542 120.554 109.633 120.554 99.8756V60.1257C120.554 50.3686 112.644 42.459 102.887 42.459Z",
    stroke: "#1BC98E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.053 60.5234L70.8751 78.7643C73.5417 80.3117 76.5701 81.1267 79.6532 81.1267C82.7363 81.1267 85.7646 80.3117 88.4313 78.7643L120.342 60.5234",
    stroke: "#1BC98E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.e77635cd274f573c807e0129efd7f3e7.svg";
export { ForwardRef as ReactComponent };